import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { Line } from '@vds/lines';
import { selectStateCache } from '../@selectors';
import { selectStateCache as selectCheckoutStateCache } from '../../@Redux/selectors/checkout.selectors';
import './desktopCart.css';
import { useDueTodayListHooks } from '../@Redux/OrderSummary.hooks';
import PriceView from './PriceView';

const DueTodayProduct = () => {
  const stateCacheCart = useSelector((state) => selectStateCache(state), shallowEqual);
  const stateCacheCheckout = useSelector((state) => selectCheckoutStateCache(state), shallowEqual);
  const { dueTodayList, dueTodayTaxList, dueTodayShipping } = useDueTodayListHooks(stateCacheCart,stateCacheCheckout);
  // const { dueMonthlyList,dueMonthlyTaxList } = useDueMonthlyListHooks(stateCache);
  const renderHTMLContent = (item) => (
    <div style={{ marginBottom: '1rem' }}>
      <div key={item?.name} style={{ display: 'flex', justifyContent: 'space-between' }}>
        <p className="content_container" style={{ width: '75%' }}>
          {item?.displayName}
          { item?.itemType === 'ACCESSORY' && item?.quantity  && <span className="productSubTitle">Quantity: {item?.quantity}</span>}
          { item?.subtitleText  && <span className="productSubTitle">{item?.subtitleText}</span>}
        </p>
        
        <PriceView item ={item} />
        {/* </div> */}
      </div>
    </div>
  );
  return (
    <div>
      {dueTodayList.dueTodayValues.map((item) => renderHTMLContent(item))}
      {dueTodayShipping && dueTodayShipping.displayName && renderHTMLContent(dueTodayShipping)}
      {dueTodayTaxList && renderHTMLContent(dueTodayTaxList)}
      <Line type="secondary" surface="light" />
    </div>
  );
};

export default DueTodayProduct;
